module.exports = __webpack_public_path__ + "media/images/flags/1x1/eun-b7f7fd043b89acfeb32479c3f8557918.svg";